import { AgentGroup } from './agent-group';
import { User } from './user';

export class Agent {
  agent_number!: string;
  agent_first_name!: string;
  agent_middle_name?: string;
  agent_nick_name?: string;
  agent_last_name!: string;
  agent_type!: string;
  agent_group_number?: string;
  details?: string;
  sex?: string;
  date_of_birth?: number;
  national_id?: string;
  street_address?: string;
  city?: string;
  country?: string;
  phone_number?: string;
  email?: string;
  bank_name?: string;
  bank_branch?: string;
  bank_account_number?: string;
  bank_account_name?: string;
  commission_per_individual_member!: number;
  commission_per_corporate_member!: number;
  // Stage 5 PR 57/60, 2026-05-16 — Sub-agent commission rework.
  // method: FIXED_PER_MEMBER | PERCENTAGE | FLAT_MONTHLY.
  // value: meaning depends on method (see BE CommissionMethod docblock).
  commission_method?: string;
  commission_value?: number;
  date_joined!: number;
  national_id_path?: string;
  agent_profile_image_path?: string;
  notes?: string;
  status!: string;
  date_approved?: number;
  date_deactivated?: number;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  agent_group?: AgentGroup;

  isPending() {
    return this.status.toLocaleLowerCase() == 'pending';
  }

  isApproved() {
    return this.status.toLocaleLowerCase() == 'approved';
  }

  isSuspended() {
    return this.status.toLocaleLowerCase() == 'suspended';
  }

  isTerminated() {
    return this.status.toLocaleLowerCase() == 'terminated';
  }


  constructor(data: any) {
    this.agent_number = data.agent_number;
    this.agent_first_name = data.agent_first_name;
    this.agent_middle_name = data.agent_middle_name;
    this.agent_nick_name = data.agent_nick_name;
    this.agent_last_name = data.agent_last_name;
    this.agent_type = data.agent_type;
    this.agent_group_number = data.agent_group_number;
    this.details = data.details;
    this.street_address = data.street_address;
    this.city = data.city;
    this.country = data.country;
    this.phone_number = data.phone_number;
    this.email = data.email;
    this.bank_name = data.bank_name;
    this.bank_branch = data.bank_branch;
    this.bank_account_number = data.bank_account_number;
    this.bank_account_name = data.bank_account_name;
    this.commission_per_individual_member = data.commission_per_individual_member;
    this.commission_per_corporate_member = data.commission_per_corporate_member;
    this.commission_method = data.commission_method;
    this.commission_value = data.commission_value;
    this.date_joined = data.date_joined;
    this.sex = data.sex;
    this.date_of_birth = data.date_of_birth;
    this.national_id = data.national_id;
    this.national_id_path = data.national_id_path;
    this.agent_profile_image_path = data.agent_profile_image_path;
    this.notes = data.notes;
    this.status = data.status;
    this.date_approved = data.date_approved;
    this.date_deactivated = data.date_deactivated;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.agent_group) {
      this.agent_group = new AgentGroup(data.agent_group);
    }
  }
}
